import * as types from "../../actionTypes";
import toast from "react-hot-toast";
import { client } from "../../../utils/axios";

const medicineAddLoading = () => ({
  type: types.MEDICINE_ADD_LOADING,
});

const medicineAddSuccess = (data) => ({
  type: types.MEDICINE_ADD_SUCCESS,
  payload: data,
});
const medicineAddFail = (error) => ({
  type: types.MEDICINE_ADD_FAIL,
  payload: error,
});

export const medicineAdd = (data) => {
  console.log("api call", data);
  return function (dispatch) {
    dispatch(medicineAddLoading());
    client
      .post(
        `/admin/upload-medicine-master`,
        data
        // {
        //   headers: { Authorization: `Bearer ${secure_token}` },
        // }
      )
      .then((resp) => {
        dispatch(medicineAddSuccess(resp.data));
        console.log("medicine Add data", resp.data);
        toast.success("File uploaded successfully.");
      })
      .catch((error) => {
        console.log("error from medicine add", error.response);
        dispatch(medicineAddFail(error));
        toast.error(`${error.response.data.message}`);
      });
  };
};
